"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTuberculosisScreeningDto = instanceOfTuberculosisScreeningDto;
exports.TuberculosisScreeningDtoFromJSON = TuberculosisScreeningDtoFromJSON;
exports.TuberculosisScreeningDtoFromJSONTyped = TuberculosisScreeningDtoFromJSONTyped;
exports.TuberculosisScreeningDtoToJSON = TuberculosisScreeningDtoToJSON;
exports.TuberculosisScreeningDtoToJSONTyped = TuberculosisScreeningDtoToJSONTyped;
const TuberculosisScreeningSymptomDto_1 = require("./TuberculosisScreeningSymptomDto");
const TuberculosisScreeningWorkHistoryQuestionDto_1 = require("./TuberculosisScreeningWorkHistoryQuestionDto");
/**
 * Check if a given object implements the TuberculosisScreeningDto interface.
 */
function instanceOfTuberculosisScreeningDto(value) {
    if (!('symptoms' in value) || value['symptoms'] === undefined)
        return false;
    if (!('workHistoryQuestions' in value) || value['workHistoryQuestions'] === undefined)
        return false;
    return true;
}
function TuberculosisScreeningDtoFromJSON(json) {
    return TuberculosisScreeningDtoFromJSONTyped(json, false);
}
function TuberculosisScreeningDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'symptoms': (json['symptoms'].map(TuberculosisScreeningSymptomDto_1.TuberculosisScreeningSymptomDtoFromJSON)),
        'workHistoryQuestions': (json['workHistoryQuestions'].map(TuberculosisScreeningWorkHistoryQuestionDto_1.TuberculosisScreeningWorkHistoryQuestionDtoFromJSON)),
        'screeningDate': json['screeningDate'] == null ? undefined : (new Date(json['screeningDate'])),
        'signature': json['signature'] == null ? undefined : json['signature'],
    };
}
function TuberculosisScreeningDtoToJSON(json) {
    return TuberculosisScreeningDtoToJSONTyped(json, false);
}
function TuberculosisScreeningDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'expiresAt': value['expiresAt'] == null ? undefined : (value['expiresAt'].toISOString()),
        'symptoms': (value['symptoms'].map(TuberculosisScreeningSymptomDto_1.TuberculosisScreeningSymptomDtoToJSON)),
        'workHistoryQuestions': (value['workHistoryQuestions'].map(TuberculosisScreeningWorkHistoryQuestionDto_1.TuberculosisScreeningWorkHistoryQuestionDtoToJSON)),
        'screeningDate': value['screeningDate'] == null ? undefined : (value['screeningDate'].toISOString()),
        'signature': value['signature'],
    };
}
//# sourceMappingURL=TuberculosisScreeningDto.js.map